<div class="vessel-voyage-form-page">
  <form [formGroup]="vesselVoyageForm">
    <mat-card>
      <h4 class="section-title">Enter Vessel Voyage Details</h4>
      <mat-card-content class="fx-align-space-evenly-stretch fx-row-wrap">
        <mat-form-field appearance="fill">
          <mat-label>Vessel Name</mat-label>
          <mat-select (selectionChange)="vesselChanged($event.value)" formControlName="vesselId"
            placeholder="Select Vessel Name" required autocomplete="off">
            <mat-option>
              <ngx-mat-select-search [searching]="searching" [formControl]="typeSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Vessel">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (item of filtered |async; track item) {
              <mat-option [value]="item.id">
                {{item.name}}
              </mat-option>
            }
          </mat-select>
          @if (vesselId.touched && vesselId.invalid && vesselId.hasError('required')) {
            <mat-error>Vessel is
            Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Voyage No</mat-label>
          <input matInput formControlName="voyageNo" placeholder="Voyage No." required autocomplete="off">
          @if (voyageNo.touched && voyageNo.invalid && voyageNo.hasError('required')) {
            <mat-error>Voyage No
            is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Consortium Name</mat-label>
          <mat-select formControlName="consortiumId" placeholder="Select Consortium" required
            autocomplete="off">
            <mat-option>
              <ngx-mat-select-search [searching]="searching" [formControl]="consortiumSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Consortium">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (item of filteredConsortiums |async; track item) {
              <mat-option [value]="item.id">
                {{item.name}}
              </mat-option>
            }
          </mat-select>
          @if (consortiumId.touched && consortiumId.invalid && consortiumId.hasError('required')) {
            <mat-error
              >Consortium
            is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Line</mat-label>
          <mat-select formControlName="lineId" placeholder="Select Line" autocomplete="off">
            <mat-option>
              <ngx-mat-select-search [searching]="searching" [formControl]="lineSearchCtrl"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Line">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (item of filteredLines |async; track item) {
              <mat-option [disabled]="item.deactivated"
                [value]="item.lineId">
                {{item.lineName}}
              </mat-option>
            }
          </mat-select>
          @if (lineId.touched && lineId.invalid && lineId.hasError('required')) {
            <mat-error>Line is
            Required</mat-error>
          }
        </mat-form-field>
      </mat-card-content>
      <mat-card-content class="card-margin">
        <h4 class="section-title">Port Details</h4>
        <div class="line-container">
          <table class="table table-border gsa-table vessel-voyage-port-table">
            <thead class="text-nowrap fx-align-space-evenly-stretch fx-row-wrap">
              <th style="flex: 1 1 14%; box-sizing: border-box;" class="width">Port</th>
              <th style="flex: 1 1 13%; box-sizing: border-box;" class="width">ETA</th>
              <th style="flex: 1 1 13%; box-sizing: border-box;" class="width">ETD</th>
              <th style="flex: 1 1 13%; box-sizing: border-box;" class="width">ATA</th>
              <th style="flex: 1 1 13%; box-sizing: border-box;" class="width">ATD</th>
              <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">Status</th>
              <th style="flex: 1 1 6%; box-sizing: border-box;" class="width text-start">Action</th>
            </thead>
            <tbody>
              @for (item of vesselVoyagePortDetails.controls; track item; let i = $index) {
                <ng-container formArrayName="vesselVoyagePortDetails"
                  >
                  <tr class="fx-align-space-evenly-stretch fx-row-wrap" [formGroupName]="i">
                    <td style="flex: 1 1 14%; box-sizing: border-box;">
                      <mat-form-field appearance="fill">
                        <mat-select (selectionChange)="portChanged(i,$event.value)"
                          formControlName="portId" placeholder="Select Port" required>
                          <mat-option>
                            <ngx-mat-select-search formControlName="portSearch"
                              placeholderLabel="Search Port"
                            noEntriesFoundLabel="No item found"></ngx-mat-select-search>
                          </mat-option>
                          <mat-option [value]="null">None</mat-option>
                          @for (c of item.get('portList').value; track c) {
                            <mat-option [disabled]="c.deactivated"
                              [value]="c.destinationId">
                              {{ c.destinationName }} ({{c.destinationCode}})
                            </mat-option>
                          }
                        </mat-select>
                        @if (vesselVoyagePortDetails.controls[i].get('portId').errors?.required) {
                          <mat-error
                            >
                            Required
                          </mat-error>
                        }
                      </mat-form-field>
                      <!-- <mat-form-field appearance="fill">
                      <mat-select (selectionChange)="portChanged(i,$event.value)" formControlName="portId" placeholder="Select Port" required>
                        <mat-option  *ngFor="let d of consortiumDestinations" [value]="d.destinationId">
                          {{d.destinationName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field> -->
                  </td>
                  <td style="flex: 1 1 13%; box-sizing: border-box;">
                    <mat-form-field appearance="fill">
                      <mat-label>ETA</mat-label>
                      <input (click)="picker.open()" (dateChange)="etaDateChangeEvent($event,item)" matInput
                        [matDatepicker]="picker" formControlName="eta"
                        autocomplete="off" readonly>
                        <mat-datepicker #picker></mat-datepicker>
                        <span matSuffix class="date-suffix">
                          <mat-datepicker-toggle [for]="picker"></mat-datepicker-toggle>
                          <mat-icon (click)="clearDate(vesselVoyagePortDetails.controls[i].get('eta'))" class="small-clear-icon">clear</mat-icon>
                        </span>
                      </mat-form-field>
                    </td>
                    <td style="flex: 1 1 13%; box-sizing: border-box;">
                      <mat-form-field appearance="fill">
                        <mat-label>ETD</mat-label>
                        <input (click)="picker1.open()" (dateChange)="etdDateChangeEvent($event,item)" matInput
                          [matDatepicker]="picker1" formControlName="etd"
                          autocomplete="off" readonly [min]="item.get('eta').value">
                          <mat-datepicker #picker1></mat-datepicker>
                          <span matSuffix class="date-suffix">
                            <mat-datepicker-toggle [for]="picker1"></mat-datepicker-toggle>
                            <mat-icon (click)="clearDate(vesselVoyagePortDetails.controls[i].get('etd'))" class="small-clear-icon">clear</mat-icon>
                          </span>
                        </mat-form-field>
                      </td>
                      <td style="flex: 1 1 13%; box-sizing: border-box;">
                        <mat-form-field appearance="fill">
                          <mat-label>ATA</mat-label>
                          <input (click)="picker2.open()" (dateChange)="aadDateChangeEvent($event,item)" matInput [max]="currentDate"
                            [matDatepicker]="picker2" formControlName="aad"
                            autocomplete="off" readonly>
                            <mat-datepicker #picker2></mat-datepicker>
                            <span matSuffix class="date-suffix">
                              <mat-datepicker-toggle [for]="picker2"></mat-datepicker-toggle>
                              <mat-icon (click)="clearDate(vesselVoyagePortDetails.controls[i].get('aad'))" class="small-clear-icon">clear</mat-icon>
                            </span>
                          </mat-form-field>
                        </td>
                        <td style="flex: 1 1 13%; box-sizing: border-box;">
                          <mat-form-field appearance="fill">
                            <mat-label>ATD</mat-label>
                            <input (click)="picker3.open()" (dateChange)="asdDateChangeEvent($event,item)" matInput [max]="currentDate"
                              [matDatepicker]="picker3" formControlName="asd"
                              autocomplete="off" readonly [min]="item.get('aad').value">
                              <mat-datepicker #picker3></mat-datepicker>
                              <span matSuffix class="date-suffix">
                                <mat-datepicker-toggle [for]="picker3"></mat-datepicker-toggle>
                                <mat-icon (click)="clearAsdDate(item)" class="small-clear-icon">clear</mat-icon>
                              </span>
                            </mat-form-field>
                          </td>
                          <td style="flex: 1 1 8%; box-sizing: border-box;">
                            <mat-form-field appearance="fill">
                              <mat-label>Status</mat-label>
                              <mat-select formControlName="isOpen">
                                <mat-option [value]="true">Open</mat-option>
                                <mat-option [value]="false">Closed</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td style="flex: 1 1 6%; box-sizing: border-box;">
                            <span class="action-cell">
                              @if (vesselVoyagePortDetails.controls.length>1) {
                                <span class="__action_delete_icon" (click)="removePortField(i)">
                                  <mat-icon>delete</mat-icon>
                                </span>
                              }
                              <span class="__action_edit_icon" (click)="addPortField()">
                                <mat-icon>add</mat-icon>
                              </span>
                            </span>
                          </td>
                        </tr>
                      </ng-container>
                    }
                  </tbody>
                </table>
              </div>
            </mat-card-content>
            <mat-card-content class="card-margin">
              <h4 class="section-title">Cut-Off's Details</h4>
              <div class="line-container">
                <table class="table table-border gsa-table vessel-voyage-cutoff-table">
                  <thead class="text-nowrap fx-align-space-evenly-stretch fx-row-wrap">
                    <th style="flex: 1 1 10%; box-sizing: border-box;" class="width ">Port</th>
                    <th style="flex: 1 1 10%; box-sizing: border-box;" class="width ">Stuffing</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">AMS</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">SI</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">Port</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">ICD Handover</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">Document Handover</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">HAZ</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">Reefer</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">ODC</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">VGM</th>
                    <th style="flex: 1 1 8%; box-sizing: border-box;" class="width">Form 13</th>
                  </thead>
                  <tbody>
                    @for (item of cutOffsDetails.controls; track item; let i = $index) {
                      <ng-container formArrayName="cutOffsDetails"
                        >
                        <tr class="fx-align-space-evenly-stretch fx-row-wrap" [formGroupName]="i">
                          <td style="flex: 1 1 10%; box-sizing: border-box;">
                            <mat-form-field appearance="fill">
                              <mat-select formControlName="portId" placeholder="Select Port" required
                                class="custom" [disabled]="true">
                                @for (c of item.get('portList').value; track c) {
                                  <mat-option
                                    [value]="c.destinationId">
                                    {{ c.destinationName }} ({{c.destinationCode}})
                                  </mat-option>
                                }
                              </mat-select>
                              @if (cutOffsDetails.controls[i].get('portId').errors?.required) {
                                <mat-error
                                  >
                                  Required
                                </mat-error>
                              }
                            </mat-form-field>
                          </td>
                          <td style="flex: 1 1 8%; box-sizing: border-box;">
                            <mat-form-field appearance="fill">
                              <mat-label>Stuffing</mat-label>
                              <input (click)="picker15.open()" matInput [matDatepicker]="picker15" (dateChange)="utcDate($event,item,'stuffing')" formControlName="stuffing" required
                                autocomplete="off" readonly>
                                <mat-datepicker #picker15></mat-datepicker>
                                <span matSuffix class="date-suffix">
                                  <mat-datepicker-toggle [for]="picker15"></mat-datepicker-toggle>
                                  <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('stuffing'))" class="small-clear-icon">clear</mat-icon>
                                </span>
                                @if (cutOffsDetails.controls[i].get('stuffing').errors?.required) {
                                  <mat-error
                                    >
                                    Required
                                  </mat-error>
                                }
                              </mat-form-field>
                            </td>
                            <td style="flex: 1 1 8%; box-sizing: border-box;">
                              <mat-form-field appearance="fill">
                                <mat-label>AMS</mat-label>
                                <input (click)="picker5.open()" matInput [matDatepicker]="picker5" (dateChange)="utcDate($event,item,'ams')" formControlName="ams"
                                  autocomplete="off" readonly>
                                  <mat-datepicker #picker5></mat-datepicker>
                                  <span matSuffix class="date-suffix">
                                    <mat-datepicker-toggle [for]="picker5"></mat-datepicker-toggle>
                                    <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('ams'))" class="small-clear-icon">clear</mat-icon>
                                  </span>
                                  @if (cutOffsDetails.controls[i].get('ams').errors?.required) {
                                    <mat-error>
                                      Required
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </td>
                              <td style="flex: 1 1 8%; box-sizing: border-box;">
                                <mat-form-field appearance="fill">
                                  <mat-label>SI</mat-label>
                                  <input (click)="picker6.open()" matInput [matDatepicker]="picker6" (dateChange)="utcDate($event,item,'si')" formControlName="si"
                                    autocomplete="off" readonly>
                                    <mat-datepicker #picker6></mat-datepicker>
                                    <span matSuffix class="date-suffix">
                                      <mat-datepicker-toggle [for]="picker6"></mat-datepicker-toggle>
                                      <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('si'))" class="small-clear-icon">clear</mat-icon>
                                    </span>
                                    @if (cutOffsDetails.controls[i].get('si').errors?.required) {
                                      <mat-error>
                                        Required
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </td>
                                <td style="flex: 1 1 8%; box-sizing: border-box;">
                                  <mat-form-field appearance="fill">
                                    <mat-label>Port</mat-label>
                                    <input (click)="picker7.open()" matInput [matDatepicker]="picker7" (dateChange)="utcDate($event,item,'port')" formControlName="port"
                                      autocomplete="off" readonly>
                                      <mat-datepicker #picker7></mat-datepicker>
                                      <span matSuffix class="date-suffix">
                                        <mat-datepicker-toggle [for]="picker7"></mat-datepicker-toggle>
                                        <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('port'))" class="small-clear-icon">clear</mat-icon>
                                      </span>
                                      @if (cutOffsDetails.controls[i].get('port').errors?.required) {
                                        <mat-error>
                                          Required
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  </td>
                                  <td style="flex: 1 1 8%; box-sizing: border-box;">
                                    <mat-form-field appearance="fill">
                                      <mat-label>ICD Handover</mat-label>
                                      <input (click)="picker8.open()" matInput [matDatepicker]="picker8" (dateChange)="utcDate($event,item,'icdHandover')"  formControlName="icdHandover"
                                        autocomplete="off" readonly>
                                        <mat-datepicker #picker8></mat-datepicker>
                                        <span matSuffix class="date-suffix">
                                          <mat-datepicker-toggle [for]="picker8"></mat-datepicker-toggle>
                                          <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('icdHandover'))" class="small-clear-icon">clear</mat-icon>
                                        </span>
                                        @if (cutOffsDetails.controls[i].get('icdHandover').errors?.required) {
                                          <mat-error
                                            >
                                            Required
                                          </mat-error>
                                        }
                                      </mat-form-field>
                                    </td>
                                    <td style="flex: 1 1 8%; box-sizing: border-box;">
                                      <mat-form-field appearance="fill">
                                        <mat-label>Document Handover</mat-label>
                                        <input (click)="picker9.open()" matInput [matDatepicker]="picker9" (dateChange)="utcDate($event,item,'docHandover')" formControlName="docHandover"
                                          autocomplete="off" readonly>
                                          <mat-datepicker #picker9></mat-datepicker>
                                          <span matSuffix class="date-suffix">
                                            <mat-datepicker-toggle [for]="picker9"></mat-datepicker-toggle>
                                            <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('docHandover'))" class="small-clear-icon">clear</mat-icon>
                                          </span>
                                          @if (cutOffsDetails.controls[i].get('docHandover').errors?.required) {
                                            <mat-error
                                              >
                                              Required
                                            </mat-error>
                                          }
                                        </mat-form-field>
                                      </td>
                                      <td style="flex: 1 1 8%; box-sizing: border-box;">
                                        <mat-form-field appearance="fill">
                                          <mat-label>HAZ</mat-label>
                                          <input (click)="picker10.open()" matInput [matDatepicker]="picker10" (dateChange)="utcDate($event,item,'haz')" formControlName="haz"
                                            autocomplete="off" readonly>
                                            <mat-datepicker #picker10></mat-datepicker>
                                            <span matSuffix class="date-suffix">
                                              <mat-datepicker-toggle [for]="picker10"></mat-datepicker-toggle>
                                              <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('haz'))" class="small-clear-icon">clear</mat-icon>
                                            </span>
                                            @if (cutOffsDetails.controls[i].get('haz').errors?.required) {
                                              <mat-error>
                                                Required
                                              </mat-error>
                                            }
                                          </mat-form-field>
                                        </td>
                                        <td style="flex: 1 1 8%; box-sizing: border-box;">
                                          <mat-form-field appearance="fill">
                                            <mat-label>Reefer</mat-label>
                                            <input (click)="picker11.open()" matInput [matDatepicker]="picker11" (dateChange)="utcDate($event,item,'reefer')" formControlName="reefer"
                                              autocomplete="off" readonly>
                                              <mat-datepicker #picker11></mat-datepicker>
                                              <span matSuffix class="date-suffix">
                                                <mat-datepicker-toggle [for]="picker11"></mat-datepicker-toggle>
                                                <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('reefer'))" class="small-clear-icon">clear</mat-icon>
                                              </span>
                                              @if (cutOffsDetails.controls[i].get('reefer').errors?.required) {
                                                <mat-error
                                                  >
                                                  Required
                                                </mat-error>
                                              }
                                            </mat-form-field>
                                          </td>
                                          <td style="flex: 1 1 8%; box-sizing: border-box;">
                                            <mat-form-field appearance="fill">
                                              <mat-label>ODC</mat-label>
                                              <input (click)="picker12.open()" matInput [matDatepicker]="picker12" (dateChange)="utcDate($event,item,'odc')" formControlName="odc"
                                                autocomplete="off" readonly>
                                                <mat-datepicker #picker12></mat-datepicker>
                                                <span matSuffix class="date-suffix">
                                                  <mat-datepicker-toggle [for]="picker12"></mat-datepicker-toggle>
                                                  <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('odc'))" class="small-clear-icon">clear</mat-icon>
                                                </span>
                                                @if (cutOffsDetails.controls[i].get('odc').errors?.required) {
                                                  <mat-error>
                                                    Required
                                                  </mat-error>
                                                }
                                              </mat-form-field>
                                            </td>
                                            <td style="flex: 1 1 8%; box-sizing: border-box;">
                                              <mat-form-field appearance="fill">
                                                <mat-label>VGM</mat-label>
                                                <input (click)="picker13.open()" matInput [matDatepicker]="picker13" (dateChange)="utcDate($event,item,'vgm')" formControlName="vgm"
                                                  autocomplete="off" readonly>
                                                  <mat-datepicker #picker13></mat-datepicker>
                                                  <span matSuffix class="date-suffix">
                                                    <mat-datepicker-toggle [for]="picker13"></mat-datepicker-toggle>
                                                    <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('vgm'))" class="small-clear-icon">clear</mat-icon>
                                                  </span>
                                                  @if (cutOffsDetails.controls[i].get('vgm').errors?.required) {
                                                    <mat-error>
                                                      Required
                                                    </mat-error>
                                                  }
                                                </mat-form-field>
                                              </td>
                                              <td style="flex: 1 1 8%; box-sizing: border-box;">
                                                <mat-form-field appearance="fill">
                                                  <mat-label>Form 13</mat-label>
                                                  <input (click)="picker14.open()" matInput [matDatepicker]="picker14" (dateChange)="utcDate($event,item,'form13')" formControlName="form13"
                                                    autocomplete="off" readonly>
                                                    <mat-datepicker #picker14></mat-datepicker>
                                                    <span matSuffix class="date-suffix">
                                                      <mat-datepicker-toggle [for]="picker14"></mat-datepicker-toggle>
                                                      <mat-icon (click)="clearDate(cutOffsDetails.controls[i].get('form13'))" class="small-clear-icon">clear</mat-icon>
                                                    </span>
                                                    @if (cutOffsDetails.controls[i].get('form13').errors?.required) {
                                                      <mat-error
                                                        >
                                                        Required
                                                      </mat-error>
                                                    }
                                                  </mat-form-field>
                                                </td>
                                              </tr>
                                            </ng-container>
                                          }
                                        </tbody>
                                      </table>
                                    </div>
                                  </mat-card-content>
                                  <mat-card-actions>
                                    @if (getSaveBtnCondition()) {
                                      <button mat-button color="primary" (click)="onSave()">Save</button>
                                    }
                                    <button mat-button color="cancel" (click)="onCancel()">Cancel</button>
                                  </mat-card-actions>
                                  @if (id.value) {
                                    <div class="audit-log">
                                      <button mat-stroked-button type="button" [class.active]="viewLog.value"
                                          (click)="viewLog.setValue(!viewLog.value)">
                                          <mat-icon>history</mat-icon> View Log
                                      </button>
                                    </div>
                                  }
                                  @if (viewLog.value) {
                                    <app-history [referenceType]="'VESSEL_VOYAGE'" [referenceId]="id.value"></app-history>
                                  }
                                </mat-card>
                              </form>
                            </div>